import { viewportSlice } from './slice'

const viewportActions = {
  ...viewportSlice.actions,
}

export default viewportActions
